module.exports = __webpack_public_path__ + "img/arrow_right_3.e5e43162.svg";